import { useEffect, useState } from 'react';

import Popover from '@mui/material/Popover';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import FormControlLabel from '@mui/material/FormControlLabel';

import {
  DatePickerHookForm,
  FormProvider,
  InputTextHookForm,
  Radio,
  RadioHookForm,
  useForm,
} from '../../input';
import Button from '../../button';

import { IPeriod, PeriodType } from '../interface';
import { zodResolver } from '@hookform/resolvers/zod';
import { CustomPeriodSchema } from './schema';
import { Tooltip } from '../../tooltip';
import { TOOLTIP_GRAPHIC_CONTENT } from '../constant';
interface ICustomPeriodMenu {
  period: IPeriod;
  onSelectPeriod: (period: IPeriod) => void;
  minStartDate?: number;
  maxEndDate?: number;
  // color?: 'primary' | 'secondary';
  triggerRef: HTMLButtonElement | null;
  open: boolean;
  handleClose: () => void;
}

export const CustomPeriodMenu = ({
  period,
  onSelectPeriod,
  minStartDate,
  maxEndDate,
  // color = 'secondary',
  triggerRef,
  open,
  handleClose,
}: ICustomPeriodMenu) => {
  const [selected, setSelected] = useState(false);

  const methods = useForm({
    resolver: zodResolver(CustomPeriodSchema),
    defaultValues: {
      type: period.type,
      value: period.value,
      startDate: period.startDate,
      endDate: period.endDate,
    },
  });

  const onSubmit = (data: IPeriod) => {
    onSelectPeriod(data);
    handleClose();
  };

  useEffect(() => {
    if (period.type === 'CUSTOM' || period.type === 'MONTHS') {
      methods.setValue('type', period.type);
      methods.setValue('value', period.value);
      methods.setValue('startDate', period.startDate);
      methods.setValue('endDate', period.endDate);

      setSelected(true);
    } else {
      methods.reset();

      setSelected(false);
    }
  }, [period]);

  return (
    <>
      {/* <Tooltip title="Período personalizado">
        <span>
          <StyledIconButton
            onClick={handleClick}
            color={color}
            selected={period.type === 'CUSTOM' ||
              period.type === 'MONTHS'}
            sx={{
              py: '10px'
            }}
          >
            <FaRegCalendar size={16} color={selected ? '#0F132A' : undefined} />
          </StyledIconButton>
        </span>
      </Tooltip> */}

      <Popover
        open={open}
        onClose={handleClose}
        anchorEl={triggerRef}
        PaperProps={{
          sx: { minWidth: 160, p: 2 },
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Stack gap={2}>
          <Stack direction="row" alignItems="center" gap={1}>
            <Typography variant="body1" fontWeight={500}>
              Período dos dados do gráfico
            </Typography>
            <Tooltip text={TOOLTIP_GRAPHIC_CONTENT} />
          </Stack>

          <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(onSubmit)}>
              <Stack gap={2}>
                <RadioHookForm name="type" sx={{ m: 0 }}>
                  <Stack gap={1}>
                    <FormControlLabel
                      value={'MONTHS' as PeriodType}
                      control={<Radio size="small" />}
                      label={
                        <Stack direction="row" gap={1} alignItems="center">
                          <InputTextHookForm
                            name="value"
                            sx={{ width: 50, height: 32, borderRadius: '4px' }}
                            onClick={() => methods.setValue('type', 'MONTHS')}
                            placeholder="1"
                          />
                          <Typography variant="body1">Meses</Typography>
                        </Stack>
                      }
                    />

                    <FormControlLabel
                      value={'CUSTOM' as PeriodType}
                      control={<Radio size="small" />}
                      label={
                        <>
                          <Typography variant="body2">Personalizado</Typography>
                          <Stack direction="row" gap={1} maxWidth="290px">
                            <DatePickerHookForm
                              name="startDate"
                              maxDate={maxEndDate}
                              minDate={minStartDate}
                              inputProps={{
                                sx: {
                                  height: 32,
                                  borderRadius: '4px',
                                  minWidth: 150,
                                },
                                placeholder: 'Data inicial',
                                onClick: () =>
                                  methods.setValue('type', 'CUSTOM'),
                              }}
                            />
                            <DatePickerHookForm
                              name="endDate"
                              maxDate={maxEndDate}
                              minDate={minStartDate}
                              inputProps={{
                                sx: {
                                  height: 32,
                                  borderRadius: '4px',
                                  minWidth: 150,
                                },
                                placeholder: 'Data final',
                                onClick: () =>
                                  methods.setValue('type', 'CUSTOM'),
                              }}
                            />
                          </Stack>
                        </>
                      }
                    />
                  </Stack>
                </RadioHookForm>
                <Button
                  variant="contained"
                  size="small"
                  type="submit"
                  color="primary"
                >
                  Aplicar
                </Button>
              </Stack>
            </form>
          </FormProvider>
        </Stack>
      </Popover>
    </>
  );
};
